export default __webpack_public_path__ + "user-icon-vr.svg";